"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SonarNotificationType = void 0;
var SonarNotificationType;
(function (SonarNotificationType) {
    SonarNotificationType["AccessLogExportReady"] = "accessLogExportReady";
    SonarNotificationType["DataDictionaryExportReady"] = "dataDictionaryExportReady";
    SonarNotificationType["IncidentLogExportReady"] = "incidentLogExportReady";
    SonarNotificationType["InitiativeCommentMention"] = "initiativeCommentMention";
    SonarNotificationType["InitiativeExportReady"] = "initiativeExportReady";
    SonarNotificationType["InitiativeLinkedJiraIssueDeleted"] = "InitiativeLinkedJiraIssueDeleted";
    SonarNotificationType["IntegrationDown"] = "integrationDown";
    SonarNotificationType["JiraIntegration"] = "jiraIntegration";
    SonarNotificationType["NewApplication"] = "newApplication";
    SonarNotificationType["NewFieldOrObjectAccess"] = "newFieldOrObjectAccess";
    SonarNotificationType["NewUser"] = "newUser";
    SonarNotificationType["AccessChangeLogExportReady"] = "accessChangeLogExportReady";
    SonarNotificationType["TimelineExportReady"] = "timelineExportReady";
    SonarNotificationType["ApiVolumeTableExportReady"] = "appVolumeTableExportReady";
    SonarNotificationType["SalesforceBulkPatchSummaryReady"] = "salesforceBulkPatchSummaryReady";
    SonarNotificationType["SetupAuditTrailExportReady"] = "setupAuditTrailExportReady";
    SonarNotificationType["NewFieldByConfigurableCriteriaAccessAlert"] = "newFieldByConfigurableCriteriaAccessAlert";
})(SonarNotificationType || (exports.SonarNotificationType = SonarNotificationType = {}));
//# sourceMappingURL=SonarNotification.js.map